// src/utils/logout.js
import { logout as logoutAction } from "state/authSlice";
import { userClient, roleClient, groupClient, accountClient } from "state/apolloClient";

/**
 * Centralized logout so we can reuse it from anywhere:
 * - Navbar "Log Out"
 * - Inactivity auto-logout
 * - Token expiry handling (later)
 */
export const performLogout = async ({ dispatch, navigate, reason } = {}) => {
  // Clear localStorage
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("roleGroupId");
  localStorage.removeItem("groupId");
  localStorage.removeItem("groupName");
  localStorage.removeItem("email");
  localStorage.removeItem("username");
  localStorage.removeItem("fullName");

  // Clear Apollo caches (non-fatal if it fails)
  try {
    await Promise.allSettled([
      userClient.clearStore(),
      roleClient.clearStore(),
      groupClient.clearStore(),
      accountClient.clearStore(),
    ]);
  } catch (e) {
    console.warn("Apollo clearStore warning:", e);
  }

  // Redux auth state reset
  if (dispatch) dispatch(logoutAction());

  // Optional: show a message on login page
  if (reason) {
    sessionStorage.setItem("logoutReason", reason);
  } else {
    sessionStorage.removeItem("logoutReason");
  }

  // Navigate to login
  if (navigate) navigate("/login", { replace: true });
};